<script setup lang="ts">
import { useCmsTranslations, useProductPrice } from "@shopware/composables";
import { defu } from "defu";
import { toRefs } from "vue";
import type { Schemas } from "#shopware";

const props = defineProps<{
  product: Schemas["Product"];
  className?: string | "";
}>();

type Translations = {
  listing: {
    variantsFrom: string;
    previously: string;
    to: string;
  };
};

let translations: Translations = {
  listing: {
    variantsFrom: "from",
    previously: "previously",
    from: "from",
    to: "to",
  },
};

translations = defu(useCmsTranslations(), translations) as Translations;

const { product, className } = toRefs(props);

const {
  price,
  unitPrice,
  displayFromVariants,
  displayFrom,
  isListPrice,
  regulationPrice,
} = useProductPrice(product);
</script>

<template>
  <div
    :id="product.id"
    :class="
      className
        ? className
        : 'font-bold font-redit_sans_con text-15px md:text-lg lg:text-28px'
    "
  >
    <SharedPrice
      v-if="isListPrice"
      class="text-base text-gray-900 basis-2/6 justify-start line-through"
      :value="price?.listPrice?.price"
    />
    <template v-if="!isListPrice">
      <div class="h-6"><!-- placeholder --></div>
    </template>
    <SharedPrice class="flex-row justify-start" :value="unitPrice">
    </SharedPrice>
    <template v-if="regulationPrice">
      <div class="flex gap-2 justify-end text-gray-500 text-3.5 mb-2">
        {{ translations.listing.previously }}
        <SharedPrice :value="regulationPrice" />
      </div>
    </template>
    <template v-if="!regulationPrice">
      <div class="h-2"><!-- placeholder --></div>
    </template>
  </div>
</template>
